import {useProjectParams} from '../../pages/ProjectPage/useProjectParams';
import {getNwIdSearchString} from '../../state/workspaces/url';
import * as urls from '../../util/urls';

export const useSingleRunBackUrl = () => {
  const {entityName, projectName} = useProjectParams();
  const baseUrl = urls.project({entityName, name: projectName});
  const nwIdSearch = getNwIdSearchString();
  return baseUrl + nwIdSearch;
};
